/** Écran de réinitialisation du mot de passe (via lien email, double saisie). */
import { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { authApi } from '../../services/api';
import { Button } from '../../components/ui/kit';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 6) { setError('Mot de passe trop court (6 caractères minimum)'); return; }
    if (password !== password2) { setError('Les deux mots de passe ne correspondent pas'); return; }
    setLoading(true);
    try {
      await authApi.resetPassword(token, password);
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Lien invalide ou expiré.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-8">
      <div className="w-full max-w-sm" data-testid="reset-form">
        <p className="kicker">Maison des Monts Bleus</p>
        <h2 className="font-title text-4xl mt-1 mb-6">Nouveau mot de passe</h2>
        {!token && <p className="text-[13px] text-red-700 mb-3">Lien de réinitialisation manquant.</p>}
        {done ? (
          <div data-testid="reset-done">
            <p className="text-[14px] text-n700 mb-5">Votre mot de passe a été modifié. Vous pouvez maintenant vous connecter.</p>
            <Button variant="primary" className="w-full h-11" onClick={() => navigate('/login')} data-testid="reset-to-login">Aller à la connexion</Button>
          </div>
        ) : (
          <form onSubmit={submit}>
            <label className="block text-[13px] text-n600 mb-1">Nouveau mot de passe</label>
            <input data-testid="reset-password" className="vd-input mb-4" type="password" value={password}
              onChange={(e) => setPassword(e.target.value)} required disabled={!token} />
            <label className="block text-[13px] text-n600 mb-1">Vérifier le nouveau mot de passe</label>
            <input data-testid="reset-password2" className="vd-input mb-4" type="password" value={password2}
              onChange={(e) => setPassword2(e.target.value)} required disabled={!token} />
            {error && <p className="text-[13px] text-red-700 mb-3" data-testid="reset-error">{error}</p>}
            <Button variant="primary" type="submit" className="w-full h-11" disabled={loading || !token} data-testid="reset-submit">
              {loading ? 'Enregistrement…' : 'Changer le mot de passe'}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
